module.exports = __webpack_public_path__ + "static/banner3-3447cb29b13fe3eae406d43ee0687772.png";